export const handleErrorMessage = () => {
    const errorMessage = document.getElementById("error-message");
    if (errorMessage) {
        if (errorMessage.textContent.trim() === "") {
            errorMessage.remove();
        } else {
            window.scrollTo({
                top: errorMessage.offsetTop,
                behavior: "smooth",
            });
        }
    }
};
